import React, { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../../../../components/Common/loading";
import { makeStyles } from "@material-ui/core/styles";
import {
	loginUser,
	removeCommonLoginToken,
} from "../../../../lib/useLocalStorageUser";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import get, { post } from "../../../../lib/requests";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	ErrorMessage,
	SuccessMessage,
} from "../../../../components/Common/toastify";
import Select from "react-select";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Slide from "@material-ui/core/Slide";
import classNames from "classnames";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import Logout from "@material-ui/icons/ExitToApp";
import { setUser, logoutUser } from "redux/ducks/userSlice";
import { removeCustomer } from "redux/ducks/customerSlice";
import { removeManageInternal } from "lib/useLocalStorageInternal";

const useStyles3 = makeStyles(javascriptStyles);
const useStyles2 = makeStyles(headersStyle);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const CustomerListDialog = (props) => {
	const { dialogToggle, setDialogToggle, loginToken } = props;
	const [loading, setLoading] = useState(false);
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [customers, setCustomers] = useState(null);
	const [option, setOption] = useState(null);
	const classes3 = useStyles3();
	const classes2 = useStyles2();
	const [selectedOption, setSelectedOption] = useState(null);
	const [selectedCustomer, setSelectedCustomer] = useState("");
	const navigate = useNavigate();

	const dispatch = useDispatch();
	const activeLoaderStyle = {
		opacity: "30%",
	};
	// form validation rules
	const validationSchema = Yup.object().shape({
		customer: Yup.string().required("customer is required"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		reset,
		formState,
		setValue,
	} = useForm(formOptions);
	const { errors } = formState;

	useEffect(() => {
		customerList();
	}, []);

	const customerList = async () => {
		setLoading(true);
		setError(null);

		await post(
			`api/master/allcustomers`,
			{
				token: loginToken,
			},
			true
		)
			.then((res) => {
				if (res.data.success) {
					setLoading(false);
					setDialogToggle(true);
					setError(null);
					const customerData = res.data.records.customers;
					//prepare customer list value and label select add option
					const customerList = customerData.map((item) => {
						return {
							value: item.conactno,
							label:
								item.company_name + " - " + item.companyno + " - " + item.conactno,
						};
					});

					setOption(customerList);
					setCustomers(customerData);
				} else {
					setLoading(false);
					ErrorMessage("Customer List", res.data.message);
				}
			})
			.catch((err) => {
				setLoading(false);
				ErrorMessage("Customer List", "Error in customer list fetching...");
			});
	};

	const logOut = async () => {
		setLoading(true);
		setError(null);
		removeCommonLoginToken();
		dispatch(logoutUser());
		dispatch(removeManageInternal());
		await axios
			.post(
				`https://apps.auscomp.au/api/logout`,
				{},
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + loginToken,
					},
				}
			)
			.then((res) => {
				if (res.data.success) {
					setLoading(false);
					setDialogToggle(false);
					setError(null);
					removeCommonLoginToken();
					dispatch(logoutUser());
					navigate("/");
				} else {
					setLoading(false);
					setError("There is no forms available.");
				}
			})
			.catch((err) => {
				setLoading(false);
				setError("Error in special forms fetching...");
			});
	};

	async function onSubmit({ customer }) {
		//filter only selected customer
		let customerItem = customers.filter((item) => item.conactno === customer);
		if (customerItem.length > 0) {
			customerItem = customerItem[0];
			customerLogin(customerItem);
		} else {
			setError("Customer not found");
		}
	}

	const customerLogin = async (customerItem) => {
		setLoading(true);
		setError(null);
		// write post request for customer login
		await post("api/master/login", {
			companyno: customerItem.companyno,
			contactno: customerItem.conactno,
			token: loginToken,
		})
			.then((res) => {
				if (res.data.success) {
					SuccessMessage("Customer Login", "Customer login successfully");
					// loginUser(res.data.records);
					dispatch(setUser(res.data.records));
					dispatch(removeCustomer());
					setDialogToggle(false);
					// navigate("/csp-dashboard");
					window.location.href = "/csp-dashboard";
				} else {
					const errorMsg = res.data.errors.map((item) => item);
					ErrorMessage("Customer Login", errorMsg);
				}
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
				ErrorMessage("Customer Login", "Error in customer login");
			});
	};

	function closeDialog() {
		setDialogToggle(false);
	}

	const changeSelection = (selectedOption) => {
		if (selectedOption?.value) {
			setSelectedOption(selectedOption);
			setSelectedCustomer(selectedOption.value);
			setValue("customer", selectedOption.value, {
				shouldValidate: true,
				shouldDirty: true,
			});
		}
	};

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal + " " + classes3.switchProfileModal,
			}}
			open={dialogToggle}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setDialogToggle(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(
					classes3.container,
					classes3.modalHeader,
					classes3.dialogTitle,
					classesCSStyles?.px5
				)}>
				<Button
					className={classes3.modalSwitchProfileCloseButton}
					key="close"
					color="transparent"
					justIcon
					aria-label="Close"
					onClick={() => setDialogToggle(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<Button
					color="transparent"
					justIcon
					className={classNames(classes3.modalSwitchProfileCloseButton)}
					key="logOut"
					aria-label="logOut"
					onClick={logOut}>
					{" "}
					<Logout className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>Switch Profile</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classNames(
					classes3.modalBody,
					classesCSStyles?.customerListHeader
				)}>
				{/* <hr /> */}

				<form onSubmit={handleSubmit(onSubmit)} id="switchProfileForm">
					{loading && (
						<Loading
							width="25"
							height="25"
							className={classNames(
								classesCSStyles?.absoluteLoading,
								classesCSStyles?.mT20
							)}
						/>
					)}
					<div style={loading ? activeLoaderStyle : {}}>
						{customers && (
							<>
								<div className="flex ">
									<label
										className={classNames(classesCSStyles.labelAc, classesCSStyles.my10)}>
										Customers<span className="text-red-600 mr-2">*</span>
									</label>
									<input
										type="hidden"
										{...register("customer")}
										value={selectedCustomer}
									/>
									<div className={classNames(classesCSStyles.width100)}>
										<Select
											options={option}
											className={classNames(
												"order-page-fild order-page-select",
												classesCSStyles.labelAc,
												classesCSStyles.my10,
												classesCSStyles.mx5,
												classesCSStyles.selectedCustomer
											)}
											defaultValue={selectedOption}
											onChange={changeSelection}
											placeholder="Select Customer"
											menuPosition={"fixed"}
											isClearable={true}
										/>
										<div className="text-red-600 text-xs pt-5">
											{errors.customer?.message}
										</div>
									</div>
								</div>
							</>
						)}
					</div>
				</form>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				<button
					form="switchProfileForm"
					className={classNames(classesCSStyles?.buttonPrimary)}
					type="submit"
					disabled={formState.isSubmitting || loading}>
					Switch
				</button>
				<Button color="danger" size="sm" disabled={loading} onClick={closeDialog}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CustomerListDialog;
